import { ContactSourceEnum } from '../../../enums/contact-source.enum';
import { ContactTitleEnum } from '../../../enums/contact-title.enum';

/**
 * Applies create-path defaults for tenant-owned contacts.
 */
export function applyTenantContactCreateDefaults<
  T extends {
    type?: unknown;
    source?: ContactSourceEnum | null;
    title?: ContactTitleEnum | null;
  },
  TType,
>(contact: T, type: TType): T {
  contact.type = (contact.type ?? type) as T['type'];
  contact.source = contact.source ?? ContactSourceEnum.WALK_IN;
  contact.title = contact.title ?? ContactTitleEnum.NONE;

  return contact;
}
